"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPickupPointsMinFee = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
const getPickupPointsMinFee = (deliveryMethods, lastPickupPointDeliveryFee, pickupPointsMaxFee) => {
  const pickupPointsMinFees = deliveryMethods.filter(deliveryMethod => deliveryMethod.type !== _globalApiClientReact.GlobalShoppingDeliveryMethodDtoType.Home).map(pickupPoint => pickupPoint.minFee).filter(fee => fee != null);
  if (pickupPointsMinFees.length) {
    return Math.min(...pickupPointsMinFees, lastPickupPointDeliveryFee ?? Number.POSITIVE_INFINITY);
  }
  if (pickupPointsMaxFee != null) {
    return lastPickupPointDeliveryFee ?? Number.POSITIVE_INFINITY;
  }
  return undefined;
};
exports.getPickupPointsMinFee = getPickupPointsMinFee;